import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import { Icon } from "@atoms";

type PersonOfficeDaysLinkProps = {
  userId: string;
};

// To the person's page, which shows their office days if the viewer may see them
export const PersonOfficeDaysLink = ({ userId }: PersonOfficeDaysLinkProps) => {
  const { t } = useTranslation();

  return (
    <Link
      to={`/people/${userId}`}
      className="flex items-center justify-center gap-2 rounded-lg bg-mapiq-black-800*/[0.04] px-4 py-3 font-semibold text-mapiq-black-800* no-underline transition-colors hover:bg-mapiq-black-800*/[0.08] hover:text-mapiq-black-800* hover:no-underline">
      {t("hereAndNow:ViewOfficeDays")}
      <Icon
        aria-hidden
        icon="caretRight"
        size="16px"
        color="currentColor"
      />
    </Link>
  );
};
